var render = function render(){var _vm=this,_c=_vm._self._c;return _c('highcharts',{staticClass:"chart",attrs:{"constructor-type":'stockChart',"options":_vm.chartOpt}})
}
var staticRenderFns = []

export { render, staticRenderFns }